<div class="filter-wrapper w-100 mb-3 px-4">
  <mat-accordion class="filter-accordion">
    <mat-expansion-panel (opened)="searchFilterOpen = true" (closed)="searchFilterOpen = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>filter_alt</mat-icon>
          Filtri
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div [formGroup]="searchFilter" class="w-100" class="row">
        <div class="form-group row">
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'map.sidebar.checkin_analysis.circuit_status' | translate }}</mat-label>
              <mat-select formControlName="status">
                <mat-option value="0">{{ 'map.sidebar.checkin_analysis.status_in_service_all' | translate }}</mat-option>
                <mat-option value="1">{{ 'map.sidebar.checkin_analysis.status_in_service_only' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div>
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>download</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onExport('html')">
        {{ 'map.map_table.export_html' | translate }}
      </button>
      <button mat-menu-item (click)="onExport('csv')">
        {{ 'map.map_table.export_csv' | translate }}
      </button>
    </mat-menu>
  </div>
</div>

<div class="map-table-content" [class.map-table-content__filter]="searchFilterOpen">
  <mtx-grid
    #grid
    [data]="dataGrid"
    [columns]="columnsGrid"
    [showColumnMenuHeader]="false"
    [noResultText]="'common.no_result' | translate"
    [showFirstLastButtons]="false"
    [rowStriped]="true"
    [showPaginator]="true"
    [emptyValuePlaceholder]="'-'"
    [pageSize]="pageSize"
    [pageOnFront]="false"
    [pageIndex]="currentPageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [length]="totalCount"
    [sortOnFront]="false"
    [sortDisabled]="false"
    sortStart="asc"
    (sortChange)="onSortChange($event)"
    (page)="onPageChange($event)"
    [expandable]="true"
    [expansionTemplate]="expansionTpl"
  >
  </mtx-grid>

  <ng-template #toOpenColTemplate let-row let-col="colDef">
    <div class="w-100 d-flex justify-content-center align-items-center">
      <mat-icon *ngIf="row.to_open" style="color: green">check</mat-icon>
      <mat-icon *ngIf="!row.to_open" style="color: red">close</mat-icon>
    </div>
  </ng-template>

  <ng-template #actionsColTemplate let-row let-col="colDef">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item class="w-100" (click)="goToFromSpliceClosure(row.splice_closure_to_open_urn)">
        <mat-icon class="me-1" color="accent">place</mat-icon>
        <span>Evidenzia su mappa</span>
      </button>

      <button mat-menu-item class="w-100" (click)="getFeatureInfo(row.splice_closure_to_open_urn)">
        <mat-icon class="me-1" color="accent">info</mat-icon>
        <span>Giunto</span>
      </button>

      <button mat-menu-item class="w-100" (click)="getFeatureInfo(row.sheath_in_urn)">
        <mat-icon class="me-1" color="accent">info</mat-icon>
        <span>Cavo IN</span>
      </button>

      <button mat-menu-item class="w-100" (click)="getFeatureInfo(row.sheath_out_urn)">
        <mat-icon class="me-1" color="accent">info</mat-icon>
        <span>Cavo OUT</span>
      </button>

      <button mat-menu-item class="w-100" (click)="getStoricoToOpen(row)">
        <mat-icon class="me-1" color="accent">history</mat-icon>
        <span>Storico</span>
      </button>
    </mat-menu>
  </ng-template>

  <ng-template #exportColTemplate let-row let-col="colDef">
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>download</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onRowExport(row, 'html')">
        {{ 'map.map_table.export_html' | translate }}
      </button>
      <button mat-menu-item (click)="onRowExport(row, 'csv')">
        {{ 'map.map_table.export_csv' | translate }}
      </button>
    </mat-menu>
  </ng-template>

  <ng-template #expansionTpl let-row>
    <mtx-grid
      #grid
      [data]="row.elements"
      [columns]="innerGridColumns"
      [showColumnMenuHeader]="false"
      [noResultText]="'common.no_result' | translate"
      [rowStriped]="true"
      [showPaginator]="false"
      [pageSize]="row.elements?.length"
      [rowClassFormatter]="rowClassFormatter"
      [emptyValuePlaceholder]="'-'"
      [length]="row.elements?.length"
      [sortOnFront]="false"
      [sortDisabled]="false"
      sortStart="asc"
      (sortChange)="onSortChange($event)"
    >
    </mtx-grid>
  </ng-template>
</div>
